import { useState, useEffect } from 'react';
import { listCalls } from '../../services/callService';
import { useProfileStore } from '../../store/useProfileStore';
import { formatDateTimeInTimezone } from './utils';
import type { MysteryShopCall } from '../../types/mysteryShop';

interface ViewPhoneCallsModalProps {
  fromNumber: string;
  onClose: () => void;
}

export function ViewPhoneCallsModal({ fromNumber, onClose }: ViewPhoneCallsModalProps) {
  const { activeProfile } = useProfileStore();
  const [calls, setCalls] = useState<MysteryShopCall[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCalls({ fromNumber }, { pageSize: 1000, orderBy: 'created', order: 'desc' }).then((results) => {
      setCalls(results);
      setLoading(false);
    });
  }, [fromNumber]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[90vh] flex flex-col">
        <div className="px-6 pt-6 pb-4 overflow-y-auto flex-1">
          <h2 className="text-lg font-bold text-gray-900 mb-1">Calls from {fromNumber}</h2>
          <p className="text-xs text-gray-500 mb-4">{loading ? '...' : `${calls.length} call${calls.length !== 1 ? 's' : ''}`}</p>
          {loading ? (
            <p className="text-sm text-gray-400">Loading...</p>
          ) : calls.length === 0 ? (
            <p className="text-sm text-gray-400">No calls found</p>
          ) : (
            <div className="divide-y divide-gray-100">
              {calls.map((c) => (
                <div key={c.id} className="py-2">
                  <p className="text-sm font-medium text-gray-900">{c.propertyName || '—'}</p>
                  <p className="text-xs text-gray-500">{formatDateTimeInTimezone(c.date, activeProfile?.timezone)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
